import React from "react";
import BigProjects from "../components/Projects/BigProjects";
import Blockchain from "../components/Projects/Blockchain";
import Node from "../components/Projects/Node";
import ReactT from "../components/Projects/React";



export default function Projects() {




    return (
        <>

            <div className="courseMiddle">

                <h1 className="HColor">Technical Skills</h1>
                <h4 className="HColor">Languages: </h4> <p>JavaScript, TypeScript, Solidity</p>
                <h4 className="HColor">Familiar with: </h4> <p>C#, Golang, Motoko, Vyper</p>
                <h4 className="HColor">Backend: </h4> <p>Node.js, Express.js, Nest.js</p>
                <h4 className="HColor">Frontend: </h4> <p>React, Next.js, Bootstrap, jQuery</p>
                <h4 className="HColor">Blockchain: </h4> <p>Ethereum, Hardhat, Foundry, Ethers.js, Web3.js, OpenZeppelin</p>
                <h4 className="HColor">Databases: </h4> <p>MongoDB, SQL (PostgreSQL, MySQL), GraphQL</p>
                <h4 className="HColor">DevOps & Tools: </h4> <p>Docker, Git, GitHub, Microsoft Azure</p>
                <h4 className="HColor">Communication & Management: </h4> <p>Slack, Microsoft Teams, Jira, GitHub Projects, Zoho</p>

            </div>


            <h2>Node.js</h2>

            <img style={{ width: "400px" }} className="planet" src="Saturn6.png" alt="Saturn" />

            <Node />


            <h2 className="morePadding">Blockchain</h2>

            <img className="planet" src="Uranus7.png" alt="Uranus" />

            <Blockchain />


            <h2 style={{ paddingBottom: "3%" }}>React</h2>

            <img className="planet" src="Neptune8.png" alt="Neptune" />

            <ReactT />


            <h2>Bigger Projects</h2>

            <img className="planet" src="Pluto9.png" alt="Pluto" />

            <BigProjects />

        </>
    )
}